<template>
  <router-view />
</template>

<script>
// @ is an alias to /src
// import NavBar from "@/components/NavBar.vue";

export default {
  name: "HomeView",
  components: {},
};
</script>

<style lang="scss">
@import "styles/custom.scss";

@import "bootstrap/scss/bootstrap.scss";
// @import '~bootstrap-vue/src/index.scss';

html,
body {
  height: 100%;
  margin: 0;
}

body {
  background-color: transparent;
}
html {
  font-weight: 200;
  background-color: #22123e !important;

  // background-image: linear-gradient(to bottom, #e4f2f1 50%, transparent 50%);
  // background-image: linear-gradient(
  //   90deg,
  //   rgb(171, 224, 255) 0.72%,
  //   rgb(126, 196, 255) 99.4%
  // );
  /* background-image: linear-gradient(to top right, purple, violet, orange); */
  // background: linear-gradient(#00b6ff, #39f, #00b6ff);
  background-size: 600% 600%;
  // -webkit-animation: gradanimate 0.5s ease infinite;
  // animation: gradanimate 10s ease infinite;
}
@-webkit-keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
@keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
// .center {
//   width: 100vw !important;
// }
</style>
